import { Component } from 'vue-property-decorator'
import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'
@Component({
    components: {
        // Import the different cell components
    },
})
export default class ClvrScreenControlHeaderCell extends ClvrComponent {}
